import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Star } from 'lucide-react';
const TESTIMONIALS = [{
  quote: 'Después de un año peleándome con el espejo, en 3 semanas empecé a mirarme sin criticarme.',
  author: 'Sofía, Buenos Aires'
}, {
  quote: 'No podía recibir un halago sin incomodarme. Hoy los acepto sin sentirme culpable.',
  author: 'Martín, Rosario'
}, {
  quote: 'Cada vez que abría Instagram terminaba sintiéndome menos. Eso se cortó por completo.',
  author: 'Daniela, La Plata'
}, {
  quote: 'Vivía postergando todo por miedo a fallar. El protocolo de 21 días me sacó del bucle.',
  author: 'Julián, Buenos Aires'
}];
export function Testimonials() {
  const [currentIndex, setCurrentIndex] = useState(0);
  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentIndex(prev => (prev + 1) % TESTIMONIALS.length);
    }, 5000);
    return () => clearInterval(timer);
  }, []);
  return <section className="py-12 bg-white/50" data-id="element-226">
      <div className="max-w-3xl mx-auto px-4 text-center" data-id="element-227">
        <div className="h-40 flex flex-col justify-center relative" data-id="element-228">
          <AnimatePresence mode="wait" data-id="element-229">
            <motion.div key={currentIndex} initial={{
            opacity: 0,
            y: 10
          }} animate={{
            opacity: 1,
            y: 0
          }} exit={{
            opacity: 0,
            y: -10
          }} transition={{
            duration: 0.5
          }} className="absolute inset-0 flex flex-col items-center justify-center" data-id="element-230">
              <div className="flex text-gold mb-4" data-id="element-231">
                {[...Array(5)].map((_, i) => <Star key={i} className="w-5 h-5 fill-current" data-id="element-232" />)}
              </div>
              <p className="font-serif text-xl md:text-2xl text-brown italic mb-4" data-id="element-233">
                "{TESTIMONIALS[currentIndex].quote}"
              </p>
              <p className="font-sans text-sm font-bold text-brown/70 uppercase tracking-wider" data-id="element-234">
                — {TESTIMONIALS[currentIndex].author}
              </p>
            </motion.div>
          </AnimatePresence>
        </div>
        
      </div>
    </section>;
}